/**
 * Every expected summary product has exactly one persisted row. A create that
 * failed is fine when its product still ends with one row: another initializer
 * made it under the same fixed id. Otherwise that create's own error says why.
 */
export function assertInitializedQuoteProducts(
  quoteDetails: readonly { productid: { productid: string } }[],
  expectedProductIds: readonly string[],
  createFailures: readonly { productId: string; reason: unknown }[] = []
) {
  for (const productId of expectedProductIds) {
    const count = quoteDetails.filter((detail) => detail.productid.productid === productId).length
    if (count !== 1) {
      const failure = createFailures.find((candidate) => candidate.productId === productId)
      if (failure) throw failure.reason
      throw new Error(`Quote initialization expected one ${productId} row; found ${count}. Refresh before editing.`)
    }
  }
}
